import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaRobot, FaSync, FaPlus, FaMinus } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

class AdminBots extends Component {
    constructor(props) {
        super(props)
        this.state = {
            bots: [],
            bot_level: 100,
            username: null,
            processing: false,
        }
    }

    componentDidMount = async () => {
        await this.loadBots()
    }

    loadBots = async () => {
        const bots = await AdminService.getBots()
        this.setState({ bots })
    }

    updateCard = async (card_uuid, scores) => {
        await AdminService.updateBotsCard(card_uuid, scores)
        NotificationManager.success('Card updated')
        this.loadBots()
    }

    updateCardXP = async (card_uuid, new_xp) => {
        await AdminService.updateBotsXP(card_uuid, new_xp)
        NotificationManager.success('Card XP updated')
        this.loadBots()
    }

    createNewBot = async () => {
        if (window.confirm("Do you confirm bot creation?")) {
            this.setState({ processing: true })
            await AdminService.createBot(this.state.bot_level, this.state.username)
            NotificationManager.success('Bot created')
            await this.loadBots()
            this.setState({ processing: false })
        }
    }

    restartBots = async () => {
        if (window.confirm("Do you confirm bot restart?")) {
            this.setState({ processing: true })
            await AdminService.resetBots()
            NotificationManager.success('Bots restarted')
            await this.loadBots()
            this.setState({ processing: false })
        }
    }

    updatePWR = async (player_uuid) => {
        this.setState({ processing: true })
        await AdminService.updateBotPower(player_uuid)
        NotificationManager.success('Bot PWR updated')
        await this.loadBots()
        this.setState({ processing: false })
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Bots Management"
                    breadcrumbs={[{ label: 'Bots' }]}
                >
                    <div className="space-y-6">
                        {/* Control Panel */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                                <FaRobot className="text-cyan-600" />
                                Bot Control Panel
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Bot Level</label>
                                        <input 
                                            type="number" 
                                            placeholder="Bot level" 
                                            value={this.state.bot_level || ''} 
                                            onChange={(e) => this.setState({ bot_level: e.target.value > 0 ? e.target.value : 1 })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Bot Username</label>
                                        <input 
                                            type="text" 
                                            placeholder="Username" 
                                            value={this.state.username || ''} 
                                            onChange={(e) => this.setState({ username: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col justify-center gap-3">
                                    {!this.state.processing ? (
                                        <>
                                            <button 
                                                onClick={this.createNewBot}
                                                className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                            >
                                                <FaPlus />
                                                Create New Bot
                                            </button>
                                            <button 
                                                onClick={this.restartBots}
                                                className="px-6 py-3 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-lg hover:from-orange-600 hover:to-red-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                            >
                                                <FaSync />
                                                Restart All Bots
                                            </button>
                                        </>
                                    ) : (
                                        <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg text-center">
                                            Processing...
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Bots List */}
                        <div className="space-y-6">
                            {this.state.bots.map(bot => (
                                <div key={bot.player_uuid} className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                    {/* Bot Header */}
                                    <div className="bg-gradient-to-r from-cyan-50 to-blue-50 px-6 py-4 border-b border-gray-200">
                                        <div className="flex items-center justify-between flex-wrap gap-3">
                                            <div className="flex items-center gap-3">
                                                <FaRobot className="text-2xl text-cyan-600" />
                                                <div>
                                                    <h3 className="text-xl font-bold text-gray-900">{bot.username}</h3>
                                                    <div className="flex items-center gap-3 text-sm">
                                                        <span className="text-gray-700">
                                                            <span className="font-semibold">Level:</span> {bot.trophies}
                                                        </span>
                                                        <span className="text-gray-700">
                                                            <span className="font-semibold">Power:</span> {bot.deck_power}
                                                        </span>
                                                        {bot.playing && (
                                                            <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                                                                PLAYING
                                                            </span>
                                                        )}
                                                        {bot.disappeared && (
                                                            <span className="px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                                                                DISAPPEARED
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <button 
                                                onClick={() => this.updatePWR(bot.player_uuid)}
                                                className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                            >
                                                <FaSync />
                                                Update PWR
                                            </button>
                                        </div>
                                    </div>

                                    {/* Cards Table */}
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-32">Power</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Top</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Right</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Bottom</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Left</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">XP</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {bot.cards.map((card, index) => (
                                                    <tr key={`card_${card.card_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-4 py-3">
                                                            <span className="font-semibold text-gray-700">{index + 1}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-lg font-bold text-cyan-600">{card.power}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center justify-center gap-2">
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0] - 1, card.scores[1], card.scores[2], card.scores[3]])}
                                                                    className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                                                                >
                                                                    <FaMinus className="text-xs" />
                                                                </button>
                                                                <span className="font-semibold text-gray-900 w-8 text-center">{card.scores[0]}</span>
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0] + 1, card.scores[1], card.scores[2], card.scores[3]])}
                                                                    className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-colors"
                                                                >
                                                                    <FaPlus className="text-xs" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center justify-center gap-2">
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1] - 1, card.scores[2], card.scores[3]])}
                                                                    className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                                                                >
                                                                    <FaMinus className="text-xs" />
                                                                </button>
                                                                <span className="font-semibold text-gray-900 w-8 text-center">{card.scores[1]}</span>
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1] + 1, card.scores[2], card.scores[3]])}
                                                                    className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-colors"
                                                                >
                                                                    <FaPlus className="text-xs" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center justify-center gap-2">
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1], card.scores[2] - 1, card.scores[3]])}
                                                                    className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                                                                >
                                                                    <FaMinus className="text-xs" />
                                                                </button>
                                                                <span className="font-semibold text-gray-900 w-8 text-center">{card.scores[2]}</span>
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1], card.scores[2] + 1, card.scores[3]])}
                                                                    className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-colors"
                                                                >
                                                                    <FaPlus className="text-xs" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center justify-center gap-2">
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1], card.scores[2], card.scores[3] - 1])}
                                                                    className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                                                                >
                                                                    <FaMinus className="text-xs" />
                                                                </button>
                                                                <span className="font-semibold text-gray-900 w-8 text-center">{card.scores[3]}</span>
                                                                <button 
                                                                    onClick={() => this.updateCard(card.card_uuid, [card.scores[0], card.scores[1], card.scores[2], card.scores[3] + 1])}
                                                                    className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-colors"
                                                                >
                                                                    <FaPlus className="text-xs" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center justify-center gap-2">
                                                                {card.xp > 1 && (
                                                                    <button 
                                                                        onClick={() => this.updateCardXP(card.card_uuid, card.xp - 1)}
                                                                        className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                                                                    >
                                                                        <FaMinus className="text-xs" />
                                                                    </button>
                                                                )}
                                                                <span className="font-semibold text-indigo-600 w-8 text-center">{card.xp}</span>
                                                                {card.xp < 99 && (
                                                                    <button 
                                                                        onClick={() => this.updateCardXP(card.card_uuid, card.xp + 1)}
                                                                        className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-colors"
                                                                    >
                                                                        <FaPlus className="text-xs" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminBots)